<template>
  <ul class="hot_content">
    <li v-for="(item,index) in list" :key="item.commentID">
      <div class="hot-comment-top">
        <div class="conTop_left">
          <div v-if="item.faceUrl!=='' && item.userID > 0" class="conTop_img"
               :style="{backgroundImage:`url(${item.faceUrl})`}"></div>
          <div v-if="item.faceUrl==='' && item.userID > 0" class="conTop_img1"></div>
          <div v-if="item.userID === -1 || item.userID === 0 || item.userID === -3" class="conTop_img2"
               :style="{backgroundImage:`url(${govImage? govImage :item.faceUrl})`}"></div>
          <img src="../../images/icon-govComments.png" v-if="item.userID === -1 || item.userID === 0 || item.userID === -3">
          <div class="conTop_name">
            <p class="conTop_name_gov themeColor" v-html="parseSpace(item.userName? item.userName :'官方发布')" v-if="item.userID === -1 || item.userID === 0 || item.userID === -3"></p>
            <p class="conTop_name_user themeColor" v-if="item.userID > 0" v-html="parseSpace(item.userName)"></p>
            <!-- <p>{{item.createTime | parseDateTime}}</p>-->
          </div>
        </div>
        <commentOperation :item="item"></commentOperation>
      </div>
      <div class="conContent" v-html="parseSpace(item.content)">
      </div>
      <p class="c-createTime">
        {{item.createTime | parseDateTime}}
        <span v-text="item.createTime | parseDateTime" style="margin-right: 10px;"></span>
        <span style="display: inline-block;" v-if="ipSwitch==1 && item.ip" v-text="!item.ipAddress && 'IP：未知' || 'IP：' + item.ipAddress "></span>
      </p>
      <div v-if="item.parentID > 0" class="news_comment_reply_info">
        <div class="news_comment_reply_info_top">
          <p class="news_comment_nickname" v-html="parseSpace(item.parentUserName)"></p>
          <!--          <commentOperation :item="item"></commentOperation>-->
        </div>
        <p class="news_comment_text" v-html="parseSpace(item.parentContent)"></p>
      </div>
    </li>
  </ul>
</template>

<script>
  import utils from '../../tool/utils'
  import submit from '../../tool/submit'
  import $ from 'jquery'
  import commentOperation from './commentOperation'

  export default {
    name: 'commentContent',
    props: ['items', 'govImage'],
    data () {
      return {
        discussID: '',
        sid: '',
        commentID: '',
        type: 1,
        eventType: 2,
        list: [],
        topicCommentPraise: localStorage.getItem('topicCommentPraise') || '',
        // eslint-disable-next-line no-undef,eqeqeq
        ipSwitch: _ipSwitch == 1 && 1 || 0
      }
    },
    created () {
      this.sid = this.$route.params.sid
      this.items.forEach((item, index) => {
        if (item && item.commentID && this.topicCommentPraise.indexOf(item.commentID) > -1) {
          item.curClass = 'news_comment_praise_img_active'
        } else {
          item.curClass = 'news_comment_praise_img_' + item.commentID
        }
        item.faceUrl ? item.faceUrl = submit.handleImgScaleUrl(item.faceUrl, 'sm') : ''
        this.list.push(item)
      })
    },
    methods: {
      clickPares: function (item) {
        if (!item) return
        var _this = this
        var data = {
          sid: _this.sid,
          id: item.commentID,
          type: 1,
          eventType: 2
        }
        submit._clickPraise(data).then((res) => {
          $('.news_comment_praise_img_' + item.commentID).addClass('news_comment_praise_img_active')
          $('.news_comment_praise_count_' + item.commentID).text(res.data.countPraise)
          if ((localStorage.getItem('topicCommentPraise') || '').indexOf(item.commentID) === -1) {
            localStorage.setItem('topicCommentPraise', (localStorage.getItem('topicCommentPraise') || '') + '_' + item.commentID)
          }
          item.countPraise = res.data.countPraise
        }).catch((err) => {
          console.log('clickPares-result-err', err)
        })
      },
      parseSpace: function (t) {
        return utils.parseSpace(t)
      }
    },
    filters: {
      parseDateTime: function (t) {
        return utils.parseDateTime(t)
      },
      parseSpace: function (t) {
        return utils.parseSpace(t)
      },
      parseCount: function (t) {
        if (!t) return
        return utils.parseCount(t)
      }
    },
    components: {
      commentOperation
    }
  }
</script>

<style scoped>
  .hot_content {
    overflow: hidden;
  }

  .hot_content li {
    padding: 0.3rem 0;
    border-bottom: 0.01rem solid #e7e7e7;
  }

  .hot_content li:last-child {
    border-bottom: none;
  }

  .hot-comment-top {
    display: flex;
    justify-content: space-between;
    align-items: end;
    margin-bottom: 0.1rem;
  }

  .conTop_left {
    overflow: hidden;
    width: 60%;
    display: flex;
    justify-content: start;
  }

  .conTop_img, .conTop_img1, .conTop_img2 {
    float: left;
  }

  .conTop_img, .conTop_img1, .conTop_img2 {
    width: 0.55rem;
    height: 0.55rem;
    border-radius: 50%;
    background-size: contain !important;
    background-position: center;
  }

  .conTop_img1 {
    background: url(../../images/icon-head.png) no-repeat;
  }

  .conTop_left img {
    float: left;
    margin-top: 0.3rem;
    margin-left: -0.22rem;
    width: 0.25rem;
    height: 0.25rem;
  }

  .conTop_name {
    max-width: calc(100% - 0.5rem - 0.2rem);
    margin-left: 0.19rem;
    font-size: 0.3rem;
    color: #a8a8a8;
  }

  .conTop_name_gov {
    color: #f39700;
    margin-bottom: 0.05rem;
  }

  .conTop_name_gov, .conTop_name_user {
    width: 100%;
    font-size: 0.3rem;
    line-height: 0.55rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .conContent, .news_comment_text {
    font-size: 0.34rem;
    line-height: 0.48rem;
    margin-left: 0.73rem;
    color: #666666;
    margin-bottom: 0.25rem;
    max-width: 100%;
  }

  .c-createTime {
    margin-left: 0.73rem;
    font-size: 0.24rem;
    line-height: 0.24rem;
    color: #a8a8a8;
  }

  .news_comment_reply_info {
    /*float: left;*/
    background-color: #f3f3f3;
    padding: 0.2rem;
    margin-bottom: 5px;
    border: none;
    border-radius: 3px;
    margin-left: 0.73rem;
    color: #666666;
    margin-top: 0.25rem;
  }

  .news_comment_reply_info_top {
    margin-bottom: 0.25rem;
    overflow: hidden;
  }

  .news_comment_nickname {
    float: left;
    display: inline-block;
    font-size: 0.3rem;
    color: var(--themeColor);
  }

  .news_comment_reply_info_top > div {
    float: right;
  }

  .news_comment_text {
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// commentContent.vue?f28ef440